var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgMap = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.666748 3.16699L6.50008 0.666992L11.5001 3.16699L16.7526 0.916159C16.816 0.888979 16.8851 0.877966 16.9539 0.884111C17.0226 0.890255 17.0887 0.913364 17.1463 0.951363C17.2038 0.989362 17.2511 1.04106 17.2837 1.10182C17.3164 1.16259 17.3335 1.23051 17.3334 1.29949V14.8337L11.5001 17.3337L6.50008 14.8337L1.24758 17.0845C1.18418 17.1117 1.11501 17.1227 1.0463 17.1165C0.977591 17.1104 0.911481 17.0873 0.853904 17.0493C0.796327 17.0113 0.749086 16.9596 0.716421 16.8988C0.683755 16.8381 0.666687 16.7701 0.666748 16.7012V3.16699ZM12.3334 15.1628L15.6667 13.7345V3.19449L12.3334 4.62283V15.1628ZM10.6667 15.0537V4.61366L7.33342 2.94699V13.387L10.6667 15.0537ZM5.66675 13.3778V2.83783L2.33342 4.26616V14.8062L5.66675 13.3778Z",
    fill: "black"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgMap, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/map.0600b046.svg";
export { ForwardRef as ReactComponent };